import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

export const roleGuard = (requiredRole: string): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.currentUser$.pipe(
      map(user => {
        if (user && user.roles?.includes(requiredRole)) {
          return true;
        }

        // Redirect to dashboard if user doesn't have the required role
        router.navigate(['/dashboard']);
        return false;
      })
    );
  };
};
